module.exports = __webpack_public_path__ + "static/media/pennant.0079fbb3.svg";